import React, { useCallback } from 'react'
import debounce from 'lodash.debounce';

function useDebounce(callback, delay,dependencies=[]) {
    const debouncedCallback = useCallback(debounce(callback ,delay),[...dependencies])
    return debouncedCallback;
}

export default useDebounce